<div class="catalog-container">

    <div class="catalog-head d-flex align-items-center">

        <!-- FILTER BUTTON -->
        <button
            class="btn btn-secondary"
            id="general-btn"
            (click)="toggleFilters()">
            {{ 'CATALOG.FILTER' | translate }}
        </button>

        <div class="filter-buttons" [class.show]="showFilters">

            <!-- CONNECTOR FILTER -->
            <div class="dropdown filter-dropdown">
                <button
                    class="btn btn-outline-primary ms-2"
                    id="filter-btn"
                    (click)="toggleDropdown('connector')">
                    {{ 'CATALOG.CONNECTOR' | translate }}
                </button>

                <ul
                    class="dropdown-menu"
                    [class.show]="openDropdown === 'connector'">

                    @for (connector of getUniqueValues('connector'); track connector) {
                        <li class="dropdown-item">

                            <label class="d-flex align-items-center w-100 mb-0" style="cursor: pointer;">
                                <input
                                    type="checkbox"
                                    class="form-check-input me-2"
                                    [checked]="filters.connector.has(connector)"
                                    (click)="onFilterToggle('connector', connector, $event)"
                                />

                                <span>{{ connector }}</span>
                            </label>

                        </li>
                    }
                </ul>

            </div>

            <!-- CONTENT TYPE FILTER -->
            <div class="dropdown filter-dropdown">
                <button
                    class="btn btn-outline-primary ms-2"
                    id="filter-btn"
                    (click)="toggleDropdown('contentType')">
                    {{ 'CATALOG.CONTENT-TYPE' | translate }}
                </button>

                <ul
                    class="dropdown-menu"
                    [class.show]="openDropdown === 'contentType'">
                    @for (type of getUniqueValues('contentType'); track type) {
                        <li class="dropdown-item">
                            <label class="d-flex align-items-center w-100 mb-0" style="cursor: pointer;">
                                <input
                                    type="checkbox"
                                    class="form-check-input me-2"
                                    [checked]="filters.contentType.has(type)"
                                    (click)="onFilterToggle('contentType', type, $event)"
                                />
                                <span>{{ type }}</span>
                            </label>
                        </li>
                    }
                </ul>
            </div>

        </div>

        <!-- SEARCH -->
        <div class="catalog-search ms-auto">
            <input
                type="text"
                class="form-control"
                #catalogSearcher
                (input)="searchCatalog()"
                placeholder="{{ 'CATALOG.SEARCH' | translate }}"
            />
        </div>

    </div>

    <!-- TABLE -->
    <div class="catalog-wrapper">
        <div class="catalog-body">
            <table class="table vertical-align" id="catalog-table">
                <thead>
                    <th 
                        id="table-header" 
                        [class.asc]="sortCriteria === 'connector' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'connector' && sortDirection === 'desc'"
                        (click)="sortAssetsBy('connector')">
                        {{ 'CATALOG.CONNECTOR' | translate }}
                    </th>
                    <th 
                        id="table-header"
                        [class.asc]="sortCriteria === 'ID' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'ID' && sortDirection === 'desc'"
                        (click)="sortAssetsBy('ID')">
                        {{ 'CATALOG.ASSET.ID' | translate }}
                    </th>
                    <th 
                        id="table-header"
                        [class.asc]="sortCriteria === 'name' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'name' && sortDirection === 'desc'"
                        (click)="sortAssetsBy('name')">
                        {{ 'CATALOG.ASSET.NAME' | translate }}
                    </th>
                    <th 
                        id="table-header"
                        [class.asc]="sortCriteria === 'originator' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'originator' && sortDirection === 'desc'"
                        (click)="sortAssetsBy('originator')">
                        {{ 'CATALOG.ASSET.ORIGINATOR' | translate }}
                    </th>
                    <th class="policy-header">
                        {{ 'CATALOG.ASSET.CONSTRAINTS' | translate }}
                    </th>
                    <th id="table-header"
                        [class.asc]="sortCriteria === 'contentType' && sortDirection === 'asc'"
                        [class.desc]="sortCriteria === 'contentType' && sortDirection === 'desc'"
                        (click)="sortAssetsBy('contentType')">
                        {{ 'CATALOG.CONTENT-TYPE' | translate }}
                    </th>
                    <th></th>
                </thead>

                <tbody>
                    @for (asset of filteredAssets; track asset) {
                        <tr>
                            <td>{{ asset.connector }}</td>
                            <td>{{ asset.ID }}</td>
                            <td>{{ asset.name }}</td>
                            <td class="text-center">
                                <div class="d-flex align-items-center justify-content-center gap-2 originator-cell">
                                    <span
                                        class="originator-truncate"
                                        [attr.title]="asset.originator ?? ''">{{ asset.originator }}
                                    </span>
                                    <button
                                        class="btn btn-outline-secondary btn-sm"
                                        id="copy-btn"
                                        (click)="copyToClipboard(asset.originator ?? '')"
                                        data-bs-toggle="tooltip"
                                        title="Copiar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-data-fill" viewBox="0 0 16 16">
                                            <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
                                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zM10 8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1"/>
                                        </svg>
                                    </button>
                                </div>
                            </td>
                            <td
                                class="text-start text-center"
                                [attr.title]="policyConstraintsTooltip(asset)">
                                {{ policyConstraintsCell(asset) }}
                            </td>
                            <td>{{ asset.contentType }}</td>
                            <td class="text-center">
                                <button type="button" class="btn" id="info-btn" (click)="openInfoAsset(asset)" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" title="{{ 'CATALOG.ASSET.INFO' | translate }}">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-info-circle info-icon" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    @if (isLoading) {
        <div class="loading-overlay">
            <div class="spinner-border"></div>
        </div>
    }

</div>

<!-- Info Asset -->

<div class="modal fade" #infoAssetModal id="infoAssetModal" tabindex="-1" aria-labelledby="infoAssetModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-dialog-centered modal-dialog-info-asset">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="infoAssetModalLabel">{{ 'CATALOG.ASSET.INFO' | translate }}</h5>
			</div>
			<div class="modal-body">
				<div class="asset-body">
					<pre><code class="json">{{ selectedAssetJSON }}</code></pre>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="closeInfoAsset()">{{ 'ADMINISTRATION.CANCEL' | translate }}</button>
			</div>
		</div>
	</div>
</div>

<!-- Toast -->

<div class="toast-container position-fixed top-0 end-0 p-3">
	<div
		#toastElement
		class="toast align-items-center text-bg-success border-0"
		role="alert"
		aria-live="assertive"
		aria-atomic="true"
	>
		<div class="d-flex">
			<div class="toast-body">
				{{ toastMessage }}
			</div>
			<button
				type="button"
				class="btn-close btn-close-white me-2 m-auto"
				data-bs-dismiss="toast"
				aria-label="Close"
			>
			</button>
		</div>
  	</div>
</div>